import { createStore, type ReadOnlyStore } from "@observe-tech/mfe-shell-api";

export interface NavApi {
  navigate(path: string, opts?: { replace?: boolean }): void;
  back(): void;
  currentPath: ReadOnlyStore<string>;
}

export function createNavApi(): NavApi {
  const path = createStore(window.location.pathname + window.location.search);
  window.addEventListener("popstate", () =>
    path.set(window.location.pathname + window.location.search),
  );
  return {
    // A router an unmounted app leaves listening (Feeding Analytics' Vue
    // router) reads a null-state pop as a foreign navigation and rewrites the
    // URL under its own base, so every entry and pop here carries a state.
    navigate: (p, opts) => {
      if (opts?.replace) {
        window.history.replaceState({}, "", p);
        window.dispatchEvent(
          new PopStateEvent("popstate", { state: window.history.state }),
        );
      } else {
        window.history.pushState({}, "", p);
      }
      path.set(p);
    },
    back: () => window.history.back(),
    currentPath: path.store,
  };
}
